<template>
    <div class="flex justify-center items-center gap-24 sm:justify-start w-fit font-medium rounded-full bg-[#F5F5F8] shadow-md top-shadow p-16">
        <div
            v-for="section in sections"
            class="group flex items-center rounded-full text-body text-primary hover:bg-primary cursor-pointer px-24 py-16"
            :class="{ 'font-medium !text-white bg-primary': section.id === activeTab }"
            :key="section.id"
            @click="selectTab(section.id)"
            @mouseover="hoverTab = section.id"
            @mouseout="hoverTab = null"
        >
            <div class="flex gap-8">
                <div
                    v-if="section.icon"
                    class="flex items-center w-full max-w-24 max-h-36"
                >
                    <img
                        :src="section.icon"
                        alt=""
                        class="w-full h-full -mt-2"
                        :style="{ filter: filterColor(section.id) }"
                    >
                </div>
                <p class="group-hover:text-white" :class="{'text-white': section.id === activeTab}">{{ getTitle(section) }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'pinia';
import {useMainStore} from '../state/store';
import Job from './Job.vue';

    export default {
        props: {
            sections: Array,
            job: Job
        },
        data() {
            return {
                error: null,
                activeTab: 0,
                hoverTab: null,
            }
        },
        computed: {
            ...mapState(useMainStore, ['selectedLocale']),
            locale() {
                return this.selectedLocale;
            },
        },
        methods: {
            filterColor(sectionId) {
                return sectionId === this.activeTab || sectionId === this.hoverTab
                    ? `brightness(0) saturate(100%) invert(90%) sepia(2%) saturate(174%) hue-rotate(201deg) brightness(109%) contrast(96%)`
                    : `brightness(0) saturate(100%) invert(23%) sepia(10%) saturate(3300%) hue-rotate(191deg) brightness(97%) contrast(91%)`;
            },
            getTitle(section) {
                let label = section.title;
                if (label[this.locale]) {
                    return label[this.locale];
                } else if (label['en']) {
                    return label['en'];
                } else {
                    for (const [key, value] of Object.entries(label)) {
                    if (value) {
                        return value;
                    }
                }
                }
            },
            selectTab(sectionId) {
                this.activeTab = sectionId
                this.$emit('tab-selected', sectionId);
            }
        },
        mounted() {
            this.activeTab = this.sections[0].id;
        }
    }
</script>

<style>
.top-shadow {
    box-shadow: 0px 4px 8px 1px rgba(0, 0, 0, 0.1);
}
</style>
